<template>
    <div class="course-detail-wrapper">
        <!--分享框架-->
        <share-ad :detail="shareData">
            <div class="main">
                <div class="cover">
                    <img :src="detailData.picture" alt="">
                </div>
                <div class="info">
                    <div class="name">{{ detailData.courseName }}</div>
                    <div :class="['brief' , !briefMore && 'show-ellipsis']">{{ detailData.introduce }}</div>
                    <div class="other">
                        <div class="watch"><van-icon size="17" name="eye-o" />{{ detailData.viewCount }}</div>
                        <div class="more" v-if="detailData.introduce && detailData.introduce.length > 52" @click="briefMore = !briefMore">{{briefMore ? '收起' : '更多'}}<van-icon size="12" :name="briefMore ? 'arrow-up' : 'arrow-down'" /></div>
                    </div>
                </div>
            </div>
            <van-tabs  animated color="#53CB85" sticky style="background: #FAFAFA" title-active-color="#53CB85">
                <van-tab title="详情">
                    <div class="section detail">
                        <div class="detail-content" v-html="detailData.details"></div>
                    </div>
                    <div class="section question" v-if="detailData.chargingFlag && !detailData.buyFlag">
                        <div class="section-title">
                            常见问题
                        </div>
                        <div class="question-content">
                            <div class="item">
                                <p class="p1">1、付费课程有效期多久？</p>
                                <p class="p2">本产品有效期从您购买之日算起，有效期<b>{{ detailData.effectiveDays }}</b>天</p>
                            </div>
                            <div class="item">
                                <p class="p1">2、购买后可以退款吗？</p>
                                <p class="p2">课程为虚拟商品，不支持退款哦！</p>
                            </div>
                            <div class="item">
                                <p class="p1">3、课程可以回看吗？</p>
                                <p class="p2">有效期内可无限次观看回放。</p>
                            </div>
                            <div class="item">
                                <p class="p1">4、其他问题及注意事项</p>
                                <p class="p2">可在【我的】页面找在线客服咨询，或在【意见反馈】中留言，我们会及时为您解答。</p>
                            </div>
                        </div>
                    </div>
                    <div class="section server" v-if="detailData.chargingFlag && detailData.buyFlag">
                        <div class="section-title">
                            服务说明
                        </div>
                        <div class="server-content">
                            <p class="p1">1、感谢您购买该课程，购买后即可生效。</p>
                            <p class="p1">2、课程为虚拟商品，不支持退款。</p>
                            <p class="p1">3、如有疑问，请联系斑斑客服。</p>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="目录">
                    <van-collapse v-model="activeNames" accordion v-if="detailData.chapterCoursewareListUnderSingle">
                        <van-collapse-item :name="i" v-for="(v,i) in detailData.chapterCoursewareListUnderSingle" :key="i">
                            <template #title>
                                <div class="course-list-card-title-icon">{{ i+1 }}</div>
                                <div class="course-list-card-title">{{ v.chapter }}</div>
                            </template>
                            <div :class="['course-list-card']" v-for="(vC,iC) in v.coursewareListUnderSingle" :key="iC">
                                第{{ iC+1 }}课｜{{vC.excerpt}}（{{vC.duration | formatSeconds}}）
                            </div>
                        </van-collapse-item>
                    </van-collapse>
                    <div class="course-list" v-if="detailData.coursewareListUnderSingle">
                        <div :class="['course-list-card']" v-for="(v,i) in detailData.coursewareListUnderSingle" :key="i">
                            第{{ i+1 }}课｜{{v.excerpt}}（{{v.duration | formatSeconds}}）
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </share-ad>
        <div class="footer" v-if="detailData.chargingFlag && !detailData.buyFlag">
            <div class="fixed">
                <div class="price">
                    <span class="f1">¥{{detailData.payConPrice ? detailData.payConPrice : detailData.payOrigPrice}}</span>
                    <span class="f2">{{detailData.effectiveDays === 365 ? `/年` : `/${detailData.effectiveDays}天`}}</span>
                    <span class="f3" v-if="detailData.payOrigPrice">¥{{detailData.payOrigPrice}}</span>
                </div>
                <div class="submit" @click="linkApp">立即开通</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Tab, Tabs, Toast, Icon, Collapse, CollapseItem } from 'vant'
export default {
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Toast.name]: Toast,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Icon.name]: Icon
    },
    name: 'seriesCourse',
    data () {
        return {
            courseId: {},
            cityCode: '',
            activeNames: 0,
            H5: '',
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            formData: {
                courseId: ''
            },
            shareData: {},
            briefMore: false,
            submitVisible: false,
            submitDisable: false,
            loading: false,
            detailData: {
                courseListUnderSeries: []
            },
            openData: {},
            selectChildData: {
                courseId: {}
            }
        }
    },
    created () {
        // 设置基础数据
        let { id, cityCode, shareType, appType } = this.$route.query
        this.courseId = id
        this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || cityCode
        this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof appType === 'object' ? appType[0] : appType)

        this.H5 = shareType === 'h5'
        this.getDetail()
        this.getSetting()
    },
    filters: {
        // 分钟计算
        formatSeconds (s) {
            s = parseInt(s)
            // 计算分钟
            // 算法：将秒数除以60，然后下舍入，既得到分钟数
            let h
            h = Math.floor(s / 60)
            // 计算秒
            // 算法：取得秒%60的余数，既得到秒数
            s = s % 60
            // 将变量转换为字符串
            h += ''
            s += ''
            // 如果只有一位数，前面增加一个0
            h = (h.length === 1) ? '0' + h : h
            s = (s.length === 1) ? '0' + s : s
            return h + '：' + s
        }
    },
    methods: {
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 获取数据
        getDetail () {
            let postData = {
                courseId: this.courseId,
                cityCode: this.cityCode
            }
            this.$api.getCourseDetail(postData).then(res => {
                if (res.status) {
                    this.detailData = res.result
                } else {
                    Toast(res.message)
                }
            })
        },
        // 获取分享配置信息
        getSetting () {
            return this.$api.getAdSetting({ code: 'microcourse-details' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.show-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
}
.course-detail-wrapper{
    .course-list{
        background: #ffffff;
    }
    .course-list-card{
        padding: 20px 23px 20px 50px;
        background: url("~@/assets/microCourse/shipin_th.png") no-repeat 23px center;
        background-size: 21px;
        font-size: 15px;
        color: #333333;
        border-bottom: 1px solid #eeeeee;
        overflow: hidden;
        width: 300px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /deep/ {
        .van-cell__title{
            display: flex;
        }
        .van-collapse-item__title{
            padding: 17px 23px;
            &::after{
                width: 100%;
                left: 0;
            }
        }
        .van-collapse-item--border::after{
            width: 100%;
            left: 0;
        }
        .van-collapse-item__content{
            padding: 0;
        }
    }
    .course-list-card-title{
        overflow: hidden;
        width: 280px;
        text-overflow: ellipsis;
        font-size: 15px;
        color: #333333;
        white-space: nowrap;
    }
    .course-list-card-title-icon{
        margin: 0 10px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        color: #FFFFFF;
        width: 21px;
        height: 21px;
        background: #53CB85;
        border-radius: 100%;
    }
    .course-list-card:last-child{
        border: 0;
    }
    .main{
        background: #ffffff;
        .cover{
            font-size: 0;
            width: 375px;
            height: 210px;
            background: #000000;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .info{
            line-height: 1;
            padding: 15px;
            .name{
                font-size: 18px;
                font-weight: 600;
                color: #333333;
            }
            .brief{
                margin: 12px 0 0 0;
                font-size: 13px;
                color: #666666;
                line-height: 24px;
            }
            .other{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 10px 0 0 0;
                font-size: 13px;
                color: #999999;
                .watch,.more{
                    display: flex;
                    align-items: center;
                }
                .watch .van-icon{
                    line-height: 0;
                    margin: 0 5px 0 0;
                }
                .more .van-icon{
                    margin: 0 0 0 5px;
                }
            }
        }
    }
    .section{
        padding: 0 10px;
        .section-title{
            background: #ffffff;
            padding: 5px 0 15px 0;
            font-size: 15px;
            font-weight: 600;
            color: #53CB85;
            text-align: center;
            border-bottom: 1px solid #eeeeee;
        }
    }
    .detail{
        padding: 0;
        .detail-content{
            background: #ffffff;
            padding: 10px;
            word-break: break-all;
            width: 100%;
            overflow: hidden;
            box-sizing: border-box;
            /deep/ img{
                width: 100% !important;
            }
        }
    }
    .question{
        padding: 0;
        .question-content{
            background: #ffffff;
            padding: 9px 15px 14px 15px;
            line-height: 1;
            .item{
                margin: 0 0 20px 0;
            }
            .item:last-child{
                margin: 0;
            }
            .p1{
                font-size: 15px;
                color: #333333;
            }
            .p2{
                margin: 7px 0 0 0;
                font-size: 13px;
                line-height: 18px;
                color: #999999;
                b{
                    font-weight: normal;
                    color: #FF5050;
                }
            }
            .p3{
                font-size: 15px;
                color: #333333;
                margin: 0 0 15px 0;
            }
            .p3:last-child{
                margin: 0;
            }
        }
    }
    .server{
        padding: 0;
        .server-content{
            background: #ffffff;
            padding: 12px 15px;
            line-height: 1;
            .p1{
                font-size: 15px;
                color: #333333;
                margin: 0 0 15px 0;
            }
            .p1:last-child{
                margin: 0;
            }
        }
    }
    .footer{
        height: 50px;
        .fixed{
            box-sizing: border-box;
            display: flex;
            align-items: center;
            position: fixed;
            bottom:0;
            left: 0;
            right: 0;
            border-top: 1px solid #eeeeee;
            height: 50px;
            background: #FFFFFF;
        }
        .price{
            text-align: center;
            flex: 1;
            .f1{
                font-size: 24px;
                font-weight: 600;
                color: #FF5050;
            }
            .f2{
                font-size: 15px;
                color: #333333;
            }
            .f3{
                text-decoration:line-through;
                margin: 0 0 0 5px;
                font-size: 15px;
                color: #999999;
            }
        }
        .submit{
            text-align: center;
            line-height: 50px;
            width: 120px;
            background: #F5DDB6;
            font-size: 18px;
            font-weight: 600;
            color: #A86F2F;
        }
    }

    /deep/ {
        .van-tab--active .van-tab__text--ellipsis,.van-tab--active .van-tab__text {
            font-size: 15px;
        }
        .van-tab__text--ellipsis,.van-tab__text {
            font-size: 13px;
        }
        .van-sticky{
            border-bottom: 1px solid #eeeeee;
        }
    }
}
</style>
